import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { MktCoopBudgetGraph } from '../../../models/mkt-coop-action';


@Component({
  templateUrl: './mkt-coop-budget-graph.component.html',
  selector: 'app-budget-graph',
})
export class MktBudgetGraphComponent implements OnInit {

  @Input() modelProvisional: MktCoopBudgetGraph[];
  @Input() modelConfirmed: MktCoopBudgetGraph[];
  @Input() title: string;
  @Input() totalBudget: string;
  @Input() graphIndex: number;

  private colorPalettes = [
    ['#D4D4D4', '#FDB060', '#C7D7AF'],
    ['#D4D4D4', '#FDB060', '#C7D7AF'],
    ['#D4D4D4', '#FDB060', '#C7D7AF']
  ];

  public optionChart: any = {
    colors: [],
    chart: {
      // type: 'bar'
      type: 'column',
      with: '100%',
    },
    accessibility: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    title: {
      text: 'Presupuestos ',
      align: 'left',
      style: {
        color: '#221F1D',
        fontSize: '15px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat,Arial, sans-serif'
      }
    },
    tooltip: {
      formatter: function () {
        var category = this.x;
        return '<b style="font-size:11px">' + category + '</b><br>' +
          this.series.name + ': ' + Highcharts.numberFormat(this.y, 0, ',', '.') + ' €';
      }
    },
    xAxis: {
      categories: [
        ''
      ]
    },
    yAxis: {
      min: 0,
      title: {
        text: ''
      }
    },
    legend: {
      reversed: true
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true
        }
      }
    },
    series: [{
      name: 'Disponible',
      data: [],
      dataLabels: {
        enabled: true,
        formatter: function () {
          return Highcharts.numberFormat(this.y, 0, ',', '.') + ' €';
        }
      }
    },
    {
      name: 'Provisionales',
      data: [],
      dataLabels: {
        enabled: true,
        formatter: function () {
          return Highcharts.numberFormat(this.y, 0, ',', '.') + ' €';
        }
      }
    },
    {
      name: 'Confirmados',
      data: [],
      dataLabels: {
        enabled: true,
        formatter: function () {
          return Highcharts.numberFormat(this.y, 0, ',', '.') + ' €';
        }
      }
    },
    ],
  };

  constructor() {
  }

  ngOnInit(): void {
    // this.loadCharts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modelProvisional'] || changes['modelConfirmed'] || changes['title'] || changes['totalBudget']) {
      this.loadCharts();
    }
  }

  loadCharts() {

    if (this.modelConfirmed && this.modelProvisional) {
      this.optionChart.colors = this.colorPalettes[this.graphIndex] || this.colorPalettes[0];
      //título.
      this.optionChart.title.text = "";
      this.optionChart.title.text += this.title;
      this.optionChart.title.text += " " + this.totalBudget + " €";

      const consumidoConfirmados = this.modelConfirmed.find(item => item.name === 'consumido')?.y || 0;
      const disponibleConfirmados = this.modelConfirmed.find(item => item.name === 'disponible')?.y || 0;

      const consumidoProvisionales = this.modelProvisional.find(item => item.name === 'consumido')?.y || 0;
      const disponibleProvisionales = this.modelProvisional.find(item => item.name === 'disponible')?.y || 0;

      const totalConfirmados = consumidoConfirmados + disponibleConfirmados;
      const totalProvisionales = consumidoProvisionales + disponibleProvisionales;

      //largo graduación debajo de las barras.
      const maxConfirmados = totalConfirmados;
      const maxProvisionales = totalProvisionales;
      const maxY = Math.max(maxConfirmados, maxProvisionales);


      const disponibleGlobal = Math.max(maxConfirmados, maxProvisionales) - (consumidoConfirmados + consumidoProvisionales)

      this.optionChart.series[0].data = [
        disponibleGlobal
      ];

      this.optionChart.series[1].data = [
        consumidoProvisionales
      ];


      this.optionChart.series[2].data = [
        consumidoConfirmados
      ];


      this.optionChart.yAxis.max = maxY;


      //porcentajes.
      this.optionChart.plotOptions.series.dataLabels.formatter = function () {
        const total = this.point.category === 'Confirmados' ? totalConfirmados : totalProvisionales;
        const porcentaje = total ? (this.y / total) * 100 : 0;
        return `${this.y}€ (${Math.round(porcentaje)}%)`;
      };

      setTimeout(() => {
        Highcharts.chart(this.title, this.optionChart);
      }, 500);

    } else {
      console.error('modelConfirmed o modelProvisional no están definidos');
    }
  }
}
